import { graphql } from "relay-runtime"

export const chMedicalReportSubscription = graphql`
  subscription chMedicalReportSubscription($patientId: ID!) {
    medicalReportAttachmentsChanged: ch_medicalReportAttachmentsChanged(patientId: $patientId) {
      attachments {
        id
        url
        updatedAt
        attachmentType
        fileName
        uploadStatus
        progressNoteId
      }
      reason
    }
  }
`
